import { draftParagraphsOf } from '../draft/blocks';
import type { ClauseDraft } from '../draft/types';
import { mostWeighted } from '../weights';

export const resolveBodySize = (draft: ClauseDraft): ClauseDraft => {
  const textRuns = draftParagraphsOf(draft.blocks).flatMap(({ runs }) => runs.filter((run) => run.kind === 'text'));
  const [heaviest] = mostWeighted(
    textRuns,
    (run) => run.format.sizePt ?? 'unsized',
    (run) => run.text.length,
  );
  return typeof heaviest === 'number' ? { ...draft, bodySizePt: heaviest } : draft;
};
